import React, { useState, useEffect } from 'react';

export const LoadingScreen = ({ isLoading, children, fadeIn = true }) => {
    const [showLoading, setShowLoading] = useState(isLoading);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        if (isLoading) {
            setShowLoading(true);
            setFadeOut(false);
        } else {
            setFadeOut(true);
            const timeout = setTimeout(() => {
                setShowLoading(false);
            }, 250);

            return () => clearTimeout(timeout);
        }
    }, [isLoading]);

    return (
        showLoading && (
            <div className={`loading ${fadeOut ? 'fade-out' : fadeIn ? 'fade-in' : ''}`}>
                {children}
            </div>
        )
    );
};
